import React, { useEffect, useState } from 'react';
import './CSS/EL_PromoteSchoolStudentsToNextYear.css';
import { useNavigate } from "react-router-dom";
import popimg from "../Common/Images/ImagesForAlert/popup_bg1.png";
import popbg from "../Common/Images/ImagesForAlert/popup_bg2.png";
import popclose from "../Common/Images/ImagesForAlert/popup_close_n.png";

interface SchoolRow {
  schoolcode: string;
  name: string;
  total_students: number;
  category?: string;
  promoted_date?: string | null;
}

const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

const thStyle: React.CSSProperties = {
  backgroundColor: '#cfe2ff',
  border: '1px solid #8cb3ff',
  padding: '6px',
  fontSize: '13px',
};

const tdStyle: React.CSSProperties = {
  borderRight: '1px solid #8cb3ff',
  borderLeft: '1px solid #8cb3ff',
  padding: '6px',
  fontSize: '13px',
};

const buttonStyle: React.CSSProperties = {
  padding: '4px 16px',
  fontSize: '13px',
  border: '1px solid #7f7f7f',
  background: 'linear-gradient(#f2f2f2, #cccccc)',
  cursor: 'pointer',
};

const EL_PromoteSchoolStudentsToNextYear: React.FC = () => {
  const [countries, setCountries] = useState<string[]>([]);
  const [country, setCountry] = useState<string>('');
  const [schools, setSchools] = useState<SchoolRow[]>([]);
  const [selectedSchool, setSelectedSchool] = useState<string>('');
  const [errorMsg, setErrorMsg] = useState<string>('');
  const navigate = useNavigate();
  document.body.style.backgroundColor = 'azure';

  useEffect(() => {
    fetch(`${API_BASE_URL}api/get_countries/`)
      .then(res => res.json())
      .then(data => {
        const sortedCountries = [...(data.countries || [])].sort((a: string, b: string) =>
          a.localeCompare(b)
        );

        setCountries(sortedCountries);
      })
      .catch(() => setErrorMsg('Failed to load countries'));
  }, []);

  /* ddlCountry_SelectedIndexChanged */
  const loadSchools = async (c: string) => {
    setCountry(c);
    setSelectedSchool('');

    const res = await fetch(`${API_BASE_URL}api/get_schooldcodestotalstudentscount/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ country: c, category: sessionStorage.getItem('category') }),
    });

    const data = await res.json();

    const rows: SchoolRow[] = (data || []).filter((s: any) => {
      if (!s) return false;
      const code = (s.schoolcode || '').toString().trim();
      if (!code) return false;
      if (code === '0' || code.toUpperCase() === 'NA') return false;
      const total = Number(s.total_students);
      if (!isNaN(total) && total <= 0) return false;

      // if backend returns category, enforce SCH or provided category
      const reqCat = sessionStorage.getItem('category');
      if (s.category && reqCat && s.category !== reqCat) return false;

      // if promoted_date is present, exclude recently promoted (within 10 months)
      if (s.promoted_date) {
        const pd = new Date(s.promoted_date);
        if (!isNaN(pd.getTime())) {
          const tenMonthsAgo = new Date();
          tenMonthsAgo.setMonth(tenMonthsAgo.getMonth() - 10);
          if (pd > tenMonthsAgo) return false;
        }
      }

      return true;
    });

    setSchools(rows);
  };

  /* Row click handler */
  const handleRowClick = (schoolCode: string) => {
    setSelectedSchool(schoolCode);
  };

  /* btnPromote_Click */
  const promote = async () => {
    if (!selectedSchool) {
      alert('Please select row to save details');
      return;
    }

    const res = await fetch(`${API_BASE_URL}api/promote-school-students/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ schoolCode: selectedSchool }),
    });

    if (!res.ok) {
      alert('Promotion failed');
      return;
    }

    alert('Students promoted successfully');
    window.location.reload();
  };

  return (
    <>
      <div
        style={{
          backgroundImage: `url(${popimg}), url(${popbg})`,
          backgroundRepeat: "no-repeat, no-repeat",
          backgroundPosition: "left center, right center",
          backgroundSize: "30% 100%, 70% 100%",
          height: "16px",
          color: "white",
          padding: "7px 0px",
          fontWeight: "bold",
          fontSize: "12pt",
          fontFamily: "arial",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "10px",
        }}
      >
        <span style={{ marginLeft: "10px" }}>
          Promoting school students to next year
        </span>
        <img
          src={popclose}
          alt="close"
          height="30px"
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/SysAdmin")}
        />
      </div>
      <div style={{ color: 'red', fontSize: '20px', textAlign: 'center', marginBottom: "10px" }}>Select country and then required school to promote students to next year.</div>
      <label
        style={{
          fontWeight: 'bold',
          display: 'block',
          marginBottom: '10px',
          marginLeft: '25%',
        }}
      >
        Country:&nbsp;
        <select
          value={country}
          onChange={e => loadSchools(e.target.value)}
          style={{ padding: '2px 6px' }}
        >
          <option value="">--Select--</option>
          {countries.map(c => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>
      </label>
      <div
        className="popup-container"
        style={{
          width: '550px',
          height: '560px',
          margin: 'auto',
          border: 'none',
          // backgroundColor: '#eaf6ff',
          // boxShadow: '0 0 6px rgba(0,0,0,0.2)',
          fontFamily: 'Tahoma, Arial, sans-serif',
          backgroundColor: "none"
        }}
      >

        <div className="popup-body" style={{ height: '480px', overflow: 'auto', border: "1px solid #5b8fd8" }}>
          <div id="SCH_divScrollableTable" style={{ width: '520px', height: '520px', overflowY: 'auto', overflowX: 'hidden', margin: '0 auto' }}>
            <table
              className="school-table"
              style={{
                width: '100%',
                tableLayout: 'fixed',
                borderCollapse: 'collapse',
                backgroundColor: 'white', margin: 0
              }}
            >
              <thead>
                <tr style={{ color: "#2859ac", fontWeight: "normal" }}>
                  <th style={{ ...thStyle, fontWeight: "normal", width: '8%' }}>#</th>
                  <th style={{ ...thStyle, fontWeight: "normal", width: '22%' }}>SchoolCode</th>
                  <th style={{ ...thStyle, fontWeight: "normal", width: '55%' }}>School Name</th>
                  <th style={{ ...thStyle, fontWeight: "normal", width: '15%', textAlign: 'center' }}>Total Students</th>
                </tr>
              </thead>

              <tbody >
                {schools.map((s, index) => {
                  const isSelected = selectedSchool === s.schoolcode;

                  return (
                    <tr
                      key={s.schoolcode}
                      onClick={() => handleRowClick(s.schoolcode)}
                      className={isSelected ? 'row-selected' : 'row-normal'}
                      style={{
                        borderBottom: '1px solid #8cb3ff',
                        backgroundColor: isSelected
                          ? 'orange'
                          : index % 2 === 0
                            ? '#f4faff'
                            : 'white',
                        color: isSelected ? 'white' : 'black',
                        cursor: 'pointer',
                        height: '30px'
                      }}
                    >
                      <td style={{ ...tdStyle, paddingLeft: '12px' }}>{index + 1}</td>
                      <td style={{ ...tdStyle, paddingLeft: '12px' }}>{s.schoolcode}</td>
                      <td style={{ ...tdStyle, paddingLeft: '12px' }}>{s.name}</td>
                      <td style={{ ...tdStyle, textAlign: 'center' }}>
                        {s.total_students}
                      </td>
                    </tr>
                  );
                })}
              </tbody>

            </table>

            {errorMsg && (
              <div style={{ color: 'red', marginTop: '10px', fontSize: '12px' }}>
                {errorMsg}
              </div>
            )}

          </div>
        </div>
        <div
          className="footer"
          style={{
            marginTop: '12px',
            display: 'flex',
            justifyContent: 'space-between',
            width: '520px',
            margin: '12px auto 0'
          }}
        >
          <button style={buttonStyle} onClick={promote}>
            Promote
          </button>
          <button style={buttonStyle} onClick={() => navigate("/SysAdmin")}>
            Close
          </button>
        </div>

      </div></>
  );
};

export default EL_PromoteSchoolStudentsToNextYear;
